export default __webpack_public_path__ + "static/media/Bg_2024_mobile.a9382300.png";